const locale = {
  GUEST_DISPLAYNAME: 'Guest',
  LOCATION: '',
  DEFAULT_LOCATION: '',
};

export default locale;
